export default "__VITE_ASSET__88010590__"